import { useEffect, useState } from 'react'
import { pushNavBanner } from './uiConfig'

// Control-bar background banner (Emerson 2026-09-18).
//
// A data URL (or '' for none) applied as the Layout header background, layered
// OVER --me-nav-color. Authored on the QA page ("Control Bar Banner"); shared
// tenant-wide via Client.ui_config['nav_banner'] like nav_color, so every user
// of the tenant sees what the brander set.
//
// Unlike navColor we deliberately do NOT cache in localStorage — a banner data
// URL can be ~MBs, too heavy to keep per-workstation. It rides the ui_config
// sync (server wins on load, applied from App.tsx) plus this in-memory value
// for live updates within the session.

const EVT = 'me-nav-banner-change'
let _current = ''

function _clean(raw: unknown): string {
  return typeof raw === 'string' && raw.startsWith('data:image/') ? raw : ''
}

export function loadNavBanner(): string {
  return _current
}

// Set the active banner (data URL) or clear it (null/''). Updates the live
// in-session value AND pushes to the tenant's server-side ui_config.
export function saveNavBanner(dataUrl: string | null): void {
  _current = _clean(dataUrl)
  window.dispatchEvent(new CustomEvent(EVT))
  pushNavBanner(_current || null)
}

// Apply the tenant's server-side banner into this session (server wins). Sets
// the in-memory value + fires the live event; does NOT push back. Called once
// on app load from App.tsx.
export function applyServerNavBanner(raw: unknown): void {
  _current = _clean(raw)
  window.dispatchEvent(new CustomEvent(EVT))
}

export function useNavBanner(): string {
  const [v, setV] = useState<string>(_current)
  useEffect(() => {
    const reload = () => setV(_current)
    window.addEventListener(EVT, reload)
    return () => window.removeEventListener(EVT, reload)
  }, [])
  return v
}
